export const PlayIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17 22"
    >
      <path
        d="M15.953 9.304 3.06 1.246C1.728.413 0 1.37 0 2.942v16.116c0 1.571 1.728 2.529 3.06 1.696l12.893-8.058a2 2 0 0 0 0-3.392Z"
        fill="currentColor"
      />
    </svg>
  );
};
